<template>
  <div v-if="model" :id="model?.system?.id" :component="!model?.system?.workflow">
    <div ref="iframe" class="iframe">
      <div
        ref="iframeContainer"
        class="iframe-container"
        :style="{ paddingBottom: `${aspectRatio * 100}%` }"
        v-html="data.code"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { IframeModel } from '~/models'
import { contentTypes } from '~/models'
import { useElementSize } from '@vueuse/core'

const type = contentTypes._iframe.elements

const props = defineProps<{ model: IframeModel }>()

const iframe = ref<HTMLElement>()
const iframeContainer = ref<HTMLElement>()

const data = {
  code: props.model?.elements?.iframeCode?.value,
  width: props.model?.elements?.width?.value || 0,
  height: props.model?.elements?.height?.value || 0
}

const aspectRatio = data.height / data.width

const { width: iFrameWidth } = useElementSize(iframe)

const setIFrameSize = (width: number, height: number) => {
  if (iframeContainer.value) {
    const iFrameElement = iframeContainer.value.querySelector('iframe')
    if (iFrameElement) {
      iFrameElement.style.width = `${width}px`
      iFrameElement.style.height = `${height}px`
    }
  }
}

watch(iFrameWidth, () => {
  if (iframe.value) {
    const width = iframe.value.getBoundingClientRect().width
    const height = iframe.value.getBoundingClientRect().height
    setIFrameSize(width, height)
  }
})

onMounted(() => {
  if (iframe.value) {
    const initialSize = iframe.value.getBoundingClientRect()
    setIFrameSize(initialSize.width, initialSize.height)
  }
})
</script>
